module.exports = __webpack_public_path__ + "static/media/cancel-1.2b0f6e46.svg";